import isEmpty from 'lodash/isEmpty';
import {
  TRIPLE_QUESTION_DROP_DOWN,
  LOCATION,
  TREATMENT_HISTORY,
  PROCEDURES,
  BIOMARKERS,
  TEXT_INPUT,
} from 'modules/questionnaire/questionTypes';

export const checkQuestionAnswer = (question, { form, files, geoLocation }) => {
  switch (question.type) {
    case TRIPLE_QUESTION_DROP_DOWN:
      return question.options.some((option) => {
        if (form[option.name] && form[option.name].length > 0 && !isEmpty(form[option.name][0]?.value)) {
          return true;
        }

        return false;
      });
    case LOCATION:
      return !isEmpty(geoLocation);
    case TREATMENT_HISTORY:
      return true;
    case PROCEDURES:
      return !isEmpty(form[question.id]);
    case BIOMARKERS:
      return !isEmpty(form[question.id]) || !isEmpty(files[question.id]);
    case TEXT_INPUT:
      return !!form[question.id];
    default:
      return !isEmpty(form[question.id]);
  }
};
